import { render, staticRenderFns } from "./ModalSectionMcp.vue?vue&type=template&id=73fe9cb7&scoped=true"
import script from "./ModalSectionMcp.vue?vue&type=script&lang=js"
export * from "./ModalSectionMcp.vue?vue&type=script&lang=js"
import style0 from "./ModalSectionMcp.vue?vue&type=style&index=0&id=73fe9cb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fe9cb7",
  null
  
)

export default component.exports